










































import { Component, Vue } from 'vue-property-decorator';
import Cookies from 'js-cookie';
import { userState, stripeState } from '@/store';
import { config } from '@/config';

@Component
export default class App extends Vue {
  public isLoading: boolean = false;

  public async created() {
    const jwt = Cookies.get('__ms.jwt');
    if (!jwt) {
      window.location.replace(config.complyAppURL);
    }

    this.isLoading = true;

    try {
      await this.fetchMe();
      await Promise.all([
        this.fetchPlans(),
        this.fetchCards(),
        this.fetchSepaDirectDebits(),
      ]);
      this.checkForRedirect();
    } catch (error) {
      console.log(error);
    }

    this.isLoading = false;
  }

  public async fetchMe() {
    const me = await this.$api.getMe();
    userState.SET_ORGANIZATION(me.organization);
    userState.SET_USER_DATA({
      firstName: me.firstName,
      lastName: me.lastName,
      email: me.email,
    });
  }

  public async fetchPlans() {
    try {
      const plans = await this.$api.getStripePlans();
      stripeState.SET_PLANS(plans);
    } catch (error) {
      console.log(error);
    }
  }

  public async fetchCards() {
    try {
      const cards = await this.$api.getCards();
      stripeState.SET_CARDS(cards);
    } catch (error) {
      console.log(error);
    }
  }

  public async fetchSepaDirectDebits() {
    try {
      const sepaDirectDebits = await this.$api.getSepaDirectDebits();
      stripeState.SET_SEPA_DIRECT_DEBITS(sepaDirectDebits);
    } catch (error) {
      console.log(error);
    }
  }

  public checkForRedirect() {
    if (
      userState?.organization?.paymentMethod === 'CREDIT_CARD' &&
      userState?.organization?.latestPaymentIntentStatus === 'FAILED'
    ) {
      this.$router.push('/verify-credit-card-payment');
    }
  }
}
